// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "registry/v1/registry.proto" (package "registry.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { VersionHistory } from "../../app/v1/app";
import { OnlineState } from "../../app/v1/app";
/**
 * @generated from protobuf message registry.v1.RegistryItemUsage
 */
export interface RegistryItemUsage {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
    /**
     * @generated from protobuf field: string part_name = 2;
     */
    partName: string;
    /**
     * @generated from protobuf field: string machine_id = 3;
     */
    machineId: string;
    /**
     * @generated from protobuf field: string machine_name = 4;
     */
    machineName: string;
    /**
     * @generated from protobuf field: string location_id = 5;
     */
    locationId: string;
    /**
     * @generated from protobuf field: string location_name = 6;
     */
    locationName: string;
    /**
     * @generated from protobuf field: string organization_id = 7;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string organization_name = 8;
     */
    organizationName: string;
    /**
     * version_pin is the merged version pin the part's rendered config resolves to for
     * this module, read from robot_part_configs_view (covers both direct and fragment usage).
     *
     * @generated from protobuf field: string version_pin = 9;
     */
    versionPin: string;
    /**
     * resolved_version is the actual version that will be used after config rendering
     *
     * @generated from protobuf field: string resolved_version = 10;
     */
    resolvedVersion: string;
    /**
     * online_state represents the online status of the part (live, offline, awaiting setup)
     *
     * @generated from protobuf field: viam.app.v1.OnlineState online_state = 12;
     */
    onlineState: OnlineState;
    /**
     * seconds_since_online is the number of seconds since the part was last online (only meaningful when offline)
     *
     * @generated from protobuf field: int64 seconds_since_online = 13;
     */
    secondsSinceOnline: string;
    /**
     * latest_platform_version is the highest non-prerelease semver of the
     * registry module that has an upload compatible with this part's
     * reported platform. Empty when we can't determine one (item isn't a
     * module, part hasn't reported a platform, no compatible upload, etc).
     * Callers compute "upgrade available" themselves by comparing against
     * resolved_version, which keeps the boolean derivation in one place
     * and gives the UI room to also show "you're already on the latest
     * X.Y.Z" without re-deriving that string from somewhere else.
     *
     * @generated from protobuf field: string latest_platform_version = 14;
     */
    latestPlatformVersion: string;
}
/**
 * @generated from protobuf message registry.v1.GetRegistryItemUsageRequest
 */
export interface GetRegistryItemUsageRequest {
    /**
     * @generated from protobuf field: string item_id = 1;
     */
    itemId: string;
    /**
     * organization_id scopes usage to the supplied org's accessible fleet
     * (its primary org plus locations shared into it). When unset, the
     * server returns Viam-wide usage and the caller must be a viam employee.
     *
     * @generated from protobuf field: optional string organization_id = 2;
     */
    organizationId?: string;
}
/**
 * @generated from protobuf message registry.v1.GetRegistryItemUsageResponse
 */
export interface GetRegistryItemUsageResponse {
    /**
     * @generated from protobuf field: repeated registry.v1.RegistryItemUsage usage = 1;
     */
    usage: RegistryItemUsage[];
}
/**
 * @generated from protobuf message registry.v1.ListAllRegistryItemsRequest
 */
export interface ListAllRegistryItemsRequest {
}
/**
 * @generated from protobuf message registry.v1.ListAllRegistryItemsResponse
 */
export interface ListAllRegistryItemsResponse {
    /**
     * @generated from protobuf field: repeated string item_ids = 1;
     */
    itemIds: string[];
}
/**
 * @generated from protobuf message registry.v1.ModuleVersionRequest
 */
export interface ModuleVersionRequest {
    /**
     * @generated from protobuf field: string resource_id = 1;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string version = 2;
     */
    version: string;
}
/**
 * @generated from protobuf message registry.v1.GetMachinePartBestModuleVersionRequest
 */
export interface GetMachinePartBestModuleVersionRequest {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
    /**
     * @generated from protobuf field: string module_id = 2;
     */
    moduleId: string;
    /**
     * @generated from protobuf field: repeated registry.v1.ModuleVersionRequest registry_module_resources = 3;
     */
    registryModuleResources: ModuleVersionRequest[];
}
/**
 * @generated from protobuf message registry.v1.ModuleDeployedVersion
 */
export interface ModuleDeployedVersion {
    /**
     * @generated from protobuf field: string resolved_version = 1;
     */
    resolvedVersion: string;
    /**
     * @generated from protobuf field: registry.v1.DeployedVersionState deployed_version_state = 2;
     */
    deployedVersionState: DeployedVersionState;
    /**
     * @generated from protobuf field: optional string overriding_version = 3;
     */
    overridingVersion?: string;
}
/**
 * @generated from protobuf message registry.v1.GetMachinePartBestModuleVersionResponse
 */
export interface GetMachinePartBestModuleVersionResponse {
    /**
     * @generated from protobuf field: map<string, registry.v1.ModuleDeployedVersion> registry_module_deployed_versions = 1;
     */
    registryModuleDeployedVersions: {
        [key: string]: ModuleDeployedVersion;
    };
}
/**
 * @generated from protobuf message registry.v1.GetRegistryItemVersionDocsRequest
 */
export interface GetRegistryItemVersionDocsRequest {
    /**
     * item_id is the registry item identifier, e.g. "namespace:module-name" or "org_id:module-name"
     *
     * @generated from protobuf field: string item_id = 1;
     */
    itemId: string;
    /**
     * version is the exact semver string, e.g. "1.2.3"
     *
     * @generated from protobuf field: string version = 2;
     */
    version: string;
}
/**
 * @generated from protobuf message registry.v1.GetRegistryItemVersionDocsResponse
 */
export interface GetRegistryItemVersionDocsResponse {
    /**
     * version_docs contains documentation for the requested version, or null if none has been published
     *
     * @generated from protobuf field: viam.app.v1.VersionHistory version_docs = 1;
     */
    versionDocs?: VersionHistory;
}
/**
 * @generated from protobuf enum registry.v1.DeployedVersionState
 */
export enum DeployedVersionState {
    /**
     * @generated from protobuf enum value: DEPLOYED_VERSION_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: DEPLOYED_VERSION_STATE_ACTIVE = 1;
     */
    ACTIVE = 1,
    /**
     * @generated from protobuf enum value: DEPLOYED_VERSION_STATE_SUPPRESSED = 2;
     */
    SUPPRESSED = 2,
    /**
     * @generated from protobuf enum value: DEPLOYED_VERSION_STATE_SUPPRESSING = 3;
     */
    SUPPRESSING = 3,
    /**
     * @generated from protobuf enum value: DEPLOYED_VERSION_STATE_INCOMPATIBLE = 4;
     */
    INCOMPATIBLE = 4,
    /**
     * @generated from protobuf enum value: DEPLOYED_VERSION_STATE_CLOSEST_VERSION_INCOMPATIBLE = 5;
     */
    CLOSEST_VERSION_INCOMPATIBLE = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class RegistryItemUsage$Type extends MessageType<RegistryItemUsage> {
    constructor() {
        super("registry.v1.RegistryItemUsage", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "part_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "machine_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "machine_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "location_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "organization_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "version_pin", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "resolved_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "online_state", kind: "enum", T: () => ["viam.app.v1.OnlineState", OnlineState, "ONLINE_STATE_"] },
            { no: 13, name: "seconds_since_online", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 14, name: "latest_platform_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message registry.v1.RegistryItemUsage
 */
export const RegistryItemUsage = new RegistryItemUsage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRegistryItemUsageRequest$Type extends MessageType<GetRegistryItemUsageRequest> {
    constructor() {
        super("registry.v1.GetRegistryItemUsageRequest", [
            { no: 1, name: "item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "organization_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message registry.v1.GetRegistryItemUsageRequest
 */
export const GetRegistryItemUsageRequest = new GetRegistryItemUsageRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRegistryItemUsageResponse$Type extends MessageType<GetRegistryItemUsageResponse> {
    constructor() {
        super("registry.v1.GetRegistryItemUsageResponse", [
            { no: 1, name: "usage", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RegistryItemUsage }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message registry.v1.GetRegistryItemUsageResponse
 */
export const GetRegistryItemUsageResponse = new GetRegistryItemUsageResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAllRegistryItemsRequest$Type extends MessageType<ListAllRegistryItemsRequest> {
    constructor() {
        super("registry.v1.ListAllRegistryItemsRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message registry.v1.ListAllRegistryItemsRequest
 */
export const ListAllRegistryItemsRequest = new ListAllRegistryItemsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAllRegistryItemsResponse$Type extends MessageType<ListAllRegistryItemsResponse> {
    constructor() {
        super("registry.v1.ListAllRegistryItemsResponse", [
            { no: 1, name: "item_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message registry.v1.ListAllRegistryItemsResponse
 */
export const ListAllRegistryItemsResponse = new ListAllRegistryItemsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ModuleVersionRequest$Type extends MessageType<ModuleVersionRequest> {
    constructor() {
        super("registry.v1.ModuleVersionRequest", [
            { no: 1, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message registry.v1.ModuleVersionRequest
 */
export const ModuleVersionRequest = new ModuleVersionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMachinePartBestModuleVersionRequest$Type extends MessageType<GetMachinePartBestModuleVersionRequest> {
    constructor() {
        super("registry.v1.GetMachinePartBestModuleVersionRequest", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "module_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "registry_module_resources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ModuleVersionRequest }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message registry.v1.GetMachinePartBestModuleVersionRequest
 */
export const GetMachinePartBestModuleVersionRequest = new GetMachinePartBestModuleVersionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ModuleDeployedVersion$Type extends MessageType<ModuleDeployedVersion> {
    constructor() {
        super("registry.v1.ModuleDeployedVersion", [
            { no: 1, name: "resolved_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "deployed_version_state", kind: "enum", T: () => ["registry.v1.DeployedVersionState", DeployedVersionState, "DEPLOYED_VERSION_STATE_"] },
            { no: 3, name: "overriding_version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message registry.v1.ModuleDeployedVersion
 */
export const ModuleDeployedVersion = new ModuleDeployedVersion$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMachinePartBestModuleVersionResponse$Type extends MessageType<GetMachinePartBestModuleVersionResponse> {
    constructor() {
        super("registry.v1.GetMachinePartBestModuleVersionResponse", [
            { no: 1, name: "registry_module_deployed_versions", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => ModuleDeployedVersion } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message registry.v1.GetMachinePartBestModuleVersionResponse
 */
export const GetMachinePartBestModuleVersionResponse = new GetMachinePartBestModuleVersionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRegistryItemVersionDocsRequest$Type extends MessageType<GetRegistryItemVersionDocsRequest> {
    constructor() {
        super("registry.v1.GetRegistryItemVersionDocsRequest", [
            { no: 1, name: "item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message registry.v1.GetRegistryItemVersionDocsRequest
 */
export const GetRegistryItemVersionDocsRequest = new GetRegistryItemVersionDocsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRegistryItemVersionDocsResponse$Type extends MessageType<GetRegistryItemVersionDocsResponse> {
    constructor() {
        super("registry.v1.GetRegistryItemVersionDocsResponse", [
            { no: 1, name: "version_docs", kind: "message", T: () => VersionHistory }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message registry.v1.GetRegistryItemVersionDocsResponse
 */
export const GetRegistryItemVersionDocsResponse = new GetRegistryItemVersionDocsResponse$Type();
/**
 * @generated ServiceType for protobuf service registry.v1.RegistryService
 */
export const RegistryService = new ServiceType("registry.v1.RegistryService", [
    { name: "GetRegistryItemUsage", options: {}, I: GetRegistryItemUsageRequest, O: GetRegistryItemUsageResponse },
    { name: "ListAllRegistryItems", options: {}, I: ListAllRegistryItemsRequest, O: ListAllRegistryItemsResponse },
    { name: "GetMachinePartBestModuleVersion", options: {}, I: GetMachinePartBestModuleVersionRequest, O: GetMachinePartBestModuleVersionResponse },
    { name: "GetRegistryItemVersionDocs", options: {}, I: GetRegistryItemVersionDocsRequest, O: GetRegistryItemVersionDocsResponse }
]);
